// @ts-strict-ignore
import { getJson } from 'utils/http';

export type UserLocation = {
  locationText: string | null | undefined;
  stateCode: string | null | undefined;
  countryCode: string | null | undefined;
  latitude: number | null | undefined;
  longitude: number | null | undefined;
};
export const fetchUserLocation = (): Promise<UserLocation> =>
  getJson('/data/user-location').then(({ location }) => location);
